export enum ModalAction {
  EDIT = 'edit',
  DELETE = 'delete',
  ADD = 'add',
}
